/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.timeline', []);